import PrepaidAmountInput from '@components/prepaid/PrepaidAmountInput';
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

import { amountAtom } from '../../../_shared/atoms/prepaidCardAtoms';
import { MAX_BALANCE_WON } from '../../../_shared/constants';
import useDailyMaxMan from '../../../_shared/hooks/useDailyMaxMan';

function CardInfo() {
    const { t } = useTranslation('prepaidCard');
    const [amount, setAmount] = useAtom(amountAtom);
    const amountMan = amount > 0 ? amount / 10000 : 0;
    const dailyMaxMan = useDailyMaxMan();
    const maxParams = { max: dailyMaxMan, maxWon: (dailyMaxMan * 10000).toLocaleString() };

    const errorText = (() => {
        if (amountMan <= 0) return undefined;
        if (amountMan > dailyMaxMan) return t('charge.errorDaily', maxParams);
        if (amountMan * 10000 > MAX_BALANCE_WON) return t('charge.errorMaxBalance');
        return undefined;
    })();

    return (
        <PrepaidAmountInput
            amountMan={amountMan}
            onChangeMan={(man) => setAmount(man * 10000)}
            errorText={errorText}
            placeholder={t('image.amountPlaceholder', maxParams)}
            tooltipDaily={t('charge.tooltipDaily', maxParams)}
            tooltipMaxBalance={t('charge.tooltipMaxBalance')}
        />
    );
}

export default CardInfo;
